import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadingController, ModalController, ToastController} from '@ionic/angular';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {BaseClass} from 'src/app/shared/classes/base';
import {TranslationService} from 'src/app/shared/services/translation.service';
import {UserVisibility} from '../../_interfaces/user-visibility';
import {UsersService} from '../../users.service';
import {AddVisibilityRuleModal} from '../add-rule/add-rule.modal';

@Component({
    selector: 'app-manage-visibility',
    templateUrl: './manage-visibility.page.html',
    styleUrls: ['./manage-visibility.page.scss']
})
export class UsersManageVisiblityPage extends BaseClass {

    public user: UserVisibility;
    public allUserRulesLength: number = null;
    public searchTextValue: string = '';

    private readonly _userId: string;
    private readonly _pageSize: number = 30;
    private _searchSubject: Subject<string> = new Subject();
    private userRulesIndex: number = 0;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _loadingController: LoadingController,
        private _modalController: ModalController,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _usersService: UsersService
    ) {
        super(_toastController, _translationService);
        this._userId = this._activatedRoute.snapshot.paramMap.get('userId');
        this._setSearchSubscription();
    }

    async ionViewWillEnter() {
        await this.loadUserRules();
    }

    public goBack(): void {
        this._router.navigate(['users/visibility']);
    }

    public async addRule(): Promise<void> {
        const modal = await this._modalController.create({
            component: AddVisibilityRuleModal,
            // cssClass: 'new-goals-input',
            componentProps: {
                userId: this._userId,
                userRules: Object.assign([], this.user.userRules)
                // 'cycleParticipantId': this._participantId,
                // 'processConfig': this.inputConfig
            }
        });

        modal.onDidDismiss().then(event => {
            if (event && event.data) {
                this.user.userRules = event.data;
            }
        });
        return await modal.present();
    }

    public async loadUserRules(): Promise<void> {
        const loading = await this._loadingController.create();
        await loading.present();

        this._usersService.getUserVisibilityRules(
            this._userId, this.searchTextValue, this.userRulesIndex, this._pageSize
        ).subscribe((response) => {
            if (response.data && response.data.userRules.length > 0) {
                if (this.userRulesIndex > 0)
                    this.user.userRules.push(...response.data.userRules);
                else {
                    this.user = response.data;
                }
            } else {
                this.user = response.data;
            }
            this.userRulesIndex = this.user.userRules.length;
            this.allUserRulesLength = response.data.allUserRulesLength;
            loading.dismiss();

        }, (error) => {
            loading.dismiss();
            this.notifyError(error);
        });
    }

    public async export(): Promise<void> {
        const loading = await this._loadingController.create();
        loading.present();

        // TODO REPLACE WITH ACTUAL ENDPOINT
        this._usersService.exportUserVisibility(
            this.user.userId
        ).subscribe(() => {
            loading.dismiss();

        }, (error) => {
            loading.dismiss();
            this.notifyError(error);
        });
    }

    public updateSearch(searchTextValue: string): void {
        this.searchTextValue = searchTextValue;
        this._searchSubject.next(searchTextValue);
    }

    private async _setSearchSubscription() {
        await this._searchSubject.pipe(
            debounceTime(1000)
        ).subscribe(async () => {
            this.userRulesIndex = 0;
            await this.loadUserRules();
        });
    }

    ngOnDestroy() {
        this._searchSubject.unsubscribe();
    }
}
